import { openInNewTab } from './open-in-new-tab';
import { redirectToUrl } from './redirect-to-url';
import { reload } from './reload';

export default {
  openInNewTab,
  redirectToUrl,
  reload,
};
